import React from 'react';
import { IPaymentProps, KeyValueRow } from '..';
import styles from '../index.module.scss';
import { PaymentData } from '../../../../../../../../store/users';

function AndroidPlatform({ data }: IPaymentProps) {
  // Type assertion since we're in AndroidPlatform component
  const androidData = data?.data as PaymentData;

  return (
    <div className="kv-list">
      <div className={styles.mb25}>
        <KeyValueRow label="Version:" value={androidData?.version} />
        <KeyValueRow label="Package Name:" value={androidData?.packageName} />

        <KeyValueRow label="DecriptedToken: Payload: Kind:" value={androidData?.decryptedToken?.payload?.kind} />
        <KeyValueRow
          className="second-row"
          label="LineItems: 0: ProductId:"
          value={androidData?.decryptedToken?.payload?.lineItems?.[0]?.productId}
        />
        <KeyValueRow
          className="third-row"
          label="Expiry Time:"
          value={androidData?.decryptedToken?.payload?.lineItems?.[0]?.expiryTime}
        />
        <KeyValueRow
          className="third-row"
          label="OfferDetails: BasePlanId:"
          value={androidData?.decryptedToken?.payload?.lineItems?.[0]?.offerDetails?.basePlanId}
        />
        <KeyValueRow
          className="third-row"
          label="AutoRenewingPlan: AutoRenewEnabled:"
          value={androidData?.decryptedToken?.payload?.lineItems?.[0]?.autoRenewingPlan?.autoRenewEnabled}
        />
      </div>
      <div className={styles.mb25}>
        <KeyValueRow
          className="second-row"
          label="Start Time:"
          value={androidData?.decryptedToken?.payload?.startTime}
        />
        <KeyValueRow
          className="second-row"
          label="Region Code:"
          value={androidData?.decryptedToken?.payload?.regionCode}
        />
        <KeyValueRow
          className="second-row"
          label="LatestOrderId:"
          value={androidData?.decryptedToken?.payload?.latestOrderId}
        />
        <KeyValueRow
          className="second-row"
          label="SubscriptionState:"
          value={androidData?.decryptedToken?.payload?.subscriptionState}
        />
        <KeyValueRow
          className="second-row"
          label="ExternalAccountIdentifiers: ObfuscatedExternalAccountId:"
          value={androidData?.decryptedToken?.payload?.externalAccountIdentifiers?.obfuscatedExternalAccountId}
        />
      </div>
      <div className={styles.mb25}>
        <KeyValueRow
          className="half-row"
          label="ErrorMessage:"
          value={androidData?.decryptedToken?.errorMessage}
        />
        <KeyValueRow
          className="half-row"
          label="IsSuccessful:"
          value={androidData?.decryptedToken?.isSuccessful}
        />
        <KeyValueRow label="EventTimeMillis:" value={androidData?.eventTimeMillis} />
        <KeyValueRow
          label="SubscriptionNotification: Version:"
          value={androidData?.subscriptionNotification?.version}
        />
        <KeyValueRow
          className="second-row"
          label="PurchaseToken:"
          value={androidData?.subscriptionNotification?.purchaseToken}
        />
        <KeyValueRow
          className="second-row"
          label="SubscriptionId:"
          value={androidData?.subscriptionNotification?.subscriptionId}
        />
        <KeyValueRow
          className="second-row"
          label="NotificationType:"
          value={androidData?.subscriptionNotification?.notificationType}
        />
      </div>
    </div>
  );
}

export default AndroidPlatform;
